import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CampaignApi from '../api/campaign/campaign.ts';

export const fetchCampaignAsync = createAsyncThunk(
    'campaign/fetchCampaign',
    async () => {
        const response = await CampaignApi();
        return response;
    }
);

const campaignSlice = createSlice({
    name: 'campaign',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCampaignAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCampaignAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCampaignAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});
export default campaignSlice.reducer;